import React from 'react'

import Table from 'react-bootstrap/Table'
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';



class MuiTableExpander extends React.Component{

    render(){
        console.log(this.props.data);
        return(
            
            <TableRow>
                <TableCell colSpan={12} className="ExpanderRow">
                         <Table striped bordered hover variant="dark" responsive={true} size="lg">
                            <tbody>
                                <tr>
                                <td>სახელი</td>
                                <td>{this.props.data[7]}</td>
                                </tr>
                                <tr>
                                <td>გვარი</td>
                                <td>{this.props.data[8]}</td>
                                </tr>
                                <tr>
                                    <td>პირადი ნომერი</td>
                                    <td>{this.props.data[14]}</td>
                                </tr>
                                <tr>
                                <td>ქალაქი</td>
                                <td>{this.props.data[10]}</td>
                                </tr>
                                <tr>
                                <td>მისამართი</td>
                                <td>{this.props.data[9]}</td>
                                </tr>
                                <tr>
                                <td>მობილური</td>
                                <td>{this.props.data[11]}</td>
                                </tr>
                                <tr className="comment">
                                <td>კომენტარი</td>
                                <td>{this.props.data[12]}</td>
                                </tr>
                            </tbody>
                        </Table>
                </TableCell>
            </TableRow>
        );
    }
}
export default MuiTableExpander;